import React, { useContext } from "react";
import classnames from "classnames";
import Link from "next/link";
import getEmailUsUrl from "@/utils/getEmailUsUrl";
import { MonetateContext, trackMonetateEvent } from "../../../context/MonetateContext";
import ContactMethodsList from "./contact-methods-list/ContactMethodsList";
import styles from "./contact-methods.module.scss";

function ContactMethods({
  newDesign = false,
  fields = [],
  solutionId = null,
  location,
  contactDetails = {},
  subHeader = "If you still need help our Partners will try their best to help",
  viewContactDetails = false,
  showGreyBackground = false,
  showEmailOption,
}) {
  const { liveChatProminenceExperiment } = useContext(MonetateContext);

  let sortedFields = fields;
  const isChatAvailable = fields.some(field => field.name === "chat");
  if (liveChatProminenceExperiment && isChatAvailable) {
    sortedFields = [...fields].sort((a, b) => (a.name === "chat") - (b.name === "chat")).reverse();
  }

  const handleEmailClick = () => {
    trackMonetateEvent("email_contact_rate");
  };

  return (
    <div className={classnames(styles.cm, fields.length === 1 ? styles.oneItem : null)}>
      <div className={styles.cm__subheader}>
        {liveChatProminenceExperiment
          ? viewContactDetails
            ? "Choose how you’d like to contact us"
            : "Find the best way to contact us below."
          : subHeader}
      </div>
      <ContactMethodsList
        fields={sortedFields}
        newDesign={newDesign}
        solutionId={solutionId}
        location={location}
        contactDetails={contactDetails}
        isChatSupported
        showGreyBackground={showGreyBackground}
      />
      {contactDetails.email?.open && showEmailOption ? (
        liveChatProminenceExperiment ? (
          <p className={styles.cm__email}>
            For quick help, chat with us or call our team. If it’s not urgent,{" "}
            <Link href={getEmailUsUrl(location)} data-test="email-us-link" onClick={handleEmailClick}>
              email us
            </Link>{" "}
            – we’ll usually reply within 24 hours, though some queries may take a little longer to resolve.
          </p>
        ) : (
          <p className={styles.cm__email}>
            Please note: if you prefer to{" "}
            <Link href={getEmailUsUrl(location)} data-test="email-us-link" onClick={handleEmailClick}>
              email us
            </Link>
            , it may take up to 24 hours for a response and longer for us to resolve your query. We recommend phone or
            chat for a quicker response and resolution.
          </p>
        )
      ) : null}
    </div>
  );
}

export default ContactMethods;
